import {
  FormControl,
  OutlinedInput,
  InputLabel,
  FormHelperText,
  Box,
  Typography,
  InputAdornment,
  TextField,
} from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const Currency = ({
  id,
  label,
  value,
  onChange,
  fullwidth,
  width,
  message,
  error,
  required,
  disabled,
}) => {
  const { getMessage, getLabel } = useLocalization();

    const handleChange = (e) => {
    let val = e.target.value;

    // Allow only digits and one decimal
    val = val.replace(/[^0-9.]/g, "");
    const parts = val.split(".");
    if (parts.length > 2) {
      val = parts[0] + "." + parts.slice(1).join("");
    }
    if (parts[1]) {
      parts[1] = parts[1].slice(0, 2);
      val = parts[0] + "." + parts[1];
    }

    onChange(val);

  };
  
    const handleBlur = () => {
    if (value) {
      const num = Number(value);
      if (!isNaN(num)) {
        // Always format with 2 decimals, preserving trailing zeros
        onChange(num.toFixed(2));
      }
    }
    };



  return (
    <Box>
      <Box sx={{ paddingLeft: "6px", paddingRight: "6px" }}>
        <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
          {getLabel(label)}
        </Typography>
      </Box>

      <FormControl
        id={id}
        fullWidth={fullwidth}
        sx={{
          width: width,
        }}
        size="small"
      >
        <OutlinedInput
          id={id}
          value={value}
          onBlur={handleBlur}
          error={error || false}
          onChange={handleChange}
          width={width}
          required={required}
          size="small"
          autoComplete="new-password"
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
          disabled={disabled}
          fullWidth={fullwidth}
          sx={{ fontSize: "12px" }}
        />

        <FormHelperText error={error || false}>
          {getMessage(message) || ""}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default Currency;
